import { useEffect, useState } from 'react';
// import ReactDOMServer from "react-dom/server";
import styles from './mapstyles.module.scss';
import leafletModule from 'leaflet';
// import dynamic from "next/dynamic";

// Dynamically import LocationMarker
// const LocationMarker = dynamic(() => import("./LocationMarker"), {
//   ssr: false,
// });

export default function MapControlls({ mapRef }) {
  const [marker, setMarker] = useState(null); // State to store the marker
  const [L, setL] = useState(null); // State to store the Leaflet module

  useEffect(() => {
    (async () => {
      setL(leafletModule);
    })();
  }, []);

  const zoomInHandler = (e) => {
    e.preventDefault();
    mapRef.current?.zoomIn();
  };

  const zoomOutHandler = () => {
    mapRef.current?.zoomOut();
  };
  // <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-75"></span>

  const customIcon = L?.divIcon({
    html: `<span class="relative flex size-6">
  <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-success/70 opacity-75"></span>
  <span class="relative inline-flex size-6 rounded-full bg-success/80 border-2 border-white"></span>
</span>`,
    className: 'bg-transparent border-0',
    iconSize: [25, 25],
  });

  const locationHandler = () => {
    if (mapRef.current && L) {
      // استفاده از locate برای دریافت موقعیت مکانی کاربر
      mapRef.current.locate({
        setView: false, // غیرفعال‌سازی تغییر مستقیم نقشه
        maxZoom: 16, // تنظیم بیشینه‌ی زوم
        watch: false, // موقعیت مکانی را به‌صورت زنده پیگیری نمی‌کند
      });

      // رویداد یافتن موقعیت مکانی
      mapRef.current.on('locationfound', (e) => {
        const { latlng } = e;

        // استفاده از flyTo برای حرکت نرم به موقعیت مکانی کاربر
        mapRef.current.flyTo(latlng, 15, {
          animate: true,
          duration: 1.5, // مدت زمان انیمیشن به ثانیه
        });

        // حذف نشانگر قبلی در صورت وجود
        if (marker) {
          marker.remove();
        }

        // ایجاد یک نشانگر جدید در موقعیت کاربر
        const newMarker = L.marker(latlng, {
          icon: customIcon,
        }).addTo(mapRef.current);

        // به‌روزرسانی نشانگر
        setMarker(newMarker);
      });

      // رویداد خطا در صورت عدم دسترسی به موقعیت مکانی
      mapRef.current.on('locationerror', (e) => {});
    } else {
    }
  };

  return (
    <div className={styles['controls-wrapper']}>
      <div className={styles['zoom-control']}>
        <div onClick={(e) => zoomInHandler(e)} className={`${styles['zoom-in-control']} transition-all`}>
          <img src="/svg/plus-.svg" alt="Zoom In" />
        </div>
        <div onClick={() => zoomOutHandler()} className={`${styles['zoom-out-control']} transition-all`}>
          <img src="/svg/minus.svg" alt="Zoom Out" />
        </div>
      </div>

      <div onClick={locationHandler} className={`${styles['control']} ${styles['location-control']} transition-all`}>
        <img src="/svg/current-location.svg" alt="Current Location" />
      </div>
    </div>
  );
}
